import { apis } from "./base";

const productsService = apis.injectEndpoints({
  endpoints: (builder) => ({
    getAllResellerProducts: builder.query({
      query: () => {
        return `/products/all`;
      },
      transformResponse: (response) => response.response.sort((a, b) => b.id - a.id),
      providesTags: ["Products"],
    }),

    getAllResellerProductsByCountryId: builder.query({
      query: (country_id) => {
        return `/admin/products/all/${country_id}`;
      },
      transformResponse: (response) => response.response,
      // transformResponse: (response) => response.response.sort((a, b) => b.id - a.id),
      providesTags: ["Products"],
    }),

    getProductById: builder.query({
      query: (id) => {
        return `/admin/products/id/${id}`;
      },
      transformResponse: (response) => response.response,
      // providesTags: ["Products"],
    }),

    getWoocommerceSiteProducts: builder.mutation({
      query: (data) => ({
        url: `/admin/woocommerce-fetch`,
        method: "POST",
        body: data,
      }),
      transformResponse: (response) => response.response,
      invalidatesTags: [],
    }),

    postProduct: builder.mutation({
      query: (data) => ({
        url: `admin/products/new`,
        method: "POST",
        body: data,
      }),
      // transformResponse: (response) => response.response
      // invalidatesTags: ["Products"],
    }),

    putProduct: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/products/edit/${id}`,
        method: "PUT",
        body: data,
      }),
      // transformResponse: (response) => response.response
      // invalidatesTags: ["Products"],
    }),

    quickPriceUpdate: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/products/quick-price-update/${id}`,
        method: "PUT",
        body: data,
      }),
      async onQueryStarted({ id, data, countryId }, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedProductResponse } = await queryFulfilled;
          const updatedProduct = updatedProductResponse.response;

          // Manually update the cache for the products list
          dispatch(
            productsService.util.updateQueryData(
              "getAllResellerProductsByCountryId",
              countryId,
              (draft) => {
                const productIndex = draft.findIndex((p) => p.id === id);
                if (productIndex !== -1) {
                  draft[productIndex].price = data.price;
                  draft[productIndex].retail_price = data.retailPrice;

                  // If it's a variation, we might need to update the parent price too
                  // However, identifying the parent in the flat list might be tricky
                  // if the backend response includes parent info, we can use it.
                  if (updatedProduct.parent_id > 0) {
                    const parentIndex = draft.findIndex((p) => p.id === updatedProduct.parent_id);
                    if (parentIndex !== -1) {
                      // We don't know the exact new min price without refetching,
                      // but if the backend returns the updated parent or we want to be safe,
                      // we'd need more info. For now, just updating the product itself
                      // avoids the full refetch jump.
                    }
                  }
                }
              }
            )
          );
        } catch {
          // If the mutation fails, we don't need to do anything as we didn't do an optimistic update
        }
      },
    }),

    convertProduct: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/products/convert-type/${id}`,
        method: "PUT",
        body: data,
      }),
      // transformResponse: (response) => response.response
      // invalidatesTags: ["Products"],
    }),

    reorderProducts: builder.mutation({
      query: (data) => ({
        url: `/admin/products/reorder/`,
        method: "PUT",
        body: { productIdsAndPriorities: data },
      }),
      // transformResponse: (response) => response.response
      invalidatesTags: ["Products"],
    }),

    reorderProductsWithoutAutoRefetch: builder.mutation({
      query: (data) => ({
        url: `/admin/products/reorder/`,
        method: "PUT",
        body: { productIdsAndPriorities: data },
      }),
      // transformResponse: (response) => response.response
      // invalidatesTags: ["Products"],
    }),

    deleteProduct: builder.mutation({
      query: (id) => ({
        url: `/admin/products/delete/${id}`,
        method: "DELETE",
      }),
      transformResponse: (response) => response.response,
      invalidatesTags: ["Products"],
    }),

    uploadProductImage: builder.mutation({
      query: (data) => ({
        url: `/admin/products/images/upload/${data.id}`,
        method: "POST",
        body: data.data,
      }),
      // transformResponse: (response) => response.response
      // invalidatesTags: ["Products"],
    }),

    getProductImagesByProductId: builder.query({
      query: (id) => {
        return `/admin/products/images/id/${id}`;
      },
      transformResponse: (response) => response.response,
      // providesTags: ["Products"],
    }),

    deleteProductImage: builder.mutation({
      query: (id) => ({
        url: `/admin/products/delete-image/${id}`,
        method: "DELETE",
      }),
      transformResponse: (response) => response.response,
      // invalidatesTags: ["Products"],
    }),

    getDistinctAttributes: builder.query({
      query: () => {
        return `/admin/products/distinct-attributes`;
      },
      transformResponse: (response) => response.response,
      providesTags: ["Products"],
    }),

    resetFeaturedProducts: builder.mutation({
      query: (countryId) => ({
        url: `/admin/products/reset-featured/${countryId}`,
        method: "PUT",
        body: {},
      }),
      // transformResponse: (response) => response.response
      invalidatesTags: ["Products"],
    }),

    // getAllCountries: builder.query({
    //     query: () => ({
    //       url: "/countries/all",
    //     }),
    //     transformResponse: (response) => response.response,
    //     // providesTags: ["Countries"],
    // }),

    // getOrderProductsByOrderId: builder.query({
    //   query: (order_id) => {
    //     return `/admin/orders/id/${order_id}`;
    // },
    //   transformResponse: (response) => response.response,
    //   providesTags: ["OrderProducts"],
    // }),

    // ---------------------------------- server products ----------------------------------//

    getAllServerProductsByCountryId: builder.query({
      query: (country_id) => {
        return `/admin/server-products/get-all/${country_id}`;
      },
      transformResponse: (response) => response.response,
      // transformResponse: (response) => response.response.sort((a, b) => b.id - a.id),
      providesTags: ["ServerProducts"],
    }),

    getServerProductById: builder.query({
      query: (id) => {
        return `/admin/server-products/get-by-id/${id}`;
      },
      transformResponse: (response) => response.response,
      // providesTags: ["ServerProducts"],
    }),

    postServerProduct: builder.mutation({
      query: (data) => ({
        url: `admin/server-products/add`,
        method: "POST",
        body: data,
      }),
      // transformResponse: (response) => response.response
      // invalidatesTags: ["ServerProducts"],
    }),

    putServerProduct: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/server-products/update/${id}`,
        method: "PUT",
        body: data,
      }),
      // transformResponse: (response) => response.response
      invalidatesTags: ["ServerProducts"],
    }),

    deleteServerProduct: builder.mutation({
      query: (id) => ({
        url: `/admin/server-products/delete/${id}`,
        method: "DELETE",
      }),
      transformResponse: (response) => response.response,
      invalidatesTags: ["ServerProducts"],
    }),

    getServerProductImagesByProductId: builder.query({
      query: (id) => {
        return `/admin/server-products/images/${id}`;
      },
      transformResponse: (response) => response.response,
      providesTags: ["ServerProductsImages"],
    }),

    deleteServerProductImage: builder.mutation({
      query: (id) => ({
        url: `/admin/server-products/images/delete/${id}`,
        method: "DELETE",
      }),
      transformResponse: (response) => response.response,
      invalidatesTags: ["ServerProductsImages"],
    }),

    uploadServerProductImage: builder.mutation({
      query: ({id, data}) => ({
        url: `/admin/server-products/images/upload/${id}`,
        method: "POST",
        body: data,
      }),
      transformResponse: (response) => response.response,
      invalidatesTags: ["ServerProductsImages"],
    }),

    getAllServerProductsQuotesByCountryId: builder.query({
      query: (country_id) => {
        return `/admin/server-products-quote/get-all/${country_id}`;
      },
      transformResponse: (response) => response.response,
      // transformResponse: (response) => response.response.sort((a, b) => b.id - a.id),
      providesTags: ["ServerProductsQuotes"],
    }),

    putServerProductQuote: builder.mutation({
      query: ({id, data}) => ({
        url: `/admin/server-products-quote/update/${id}`,
        method: "PUT",
        body: data,
      }),
      // transformResponse: (response) => response.response
      invalidatesTags: ["ServerProductsQuotes", "ServerProducts"],
    }),

    deleteServerProductQuote: builder.mutation({
      query: (id) => ({
        url: `/admin/server-products-quote/delete/${id}`,
        method: "DELETE",
      }),
      transformResponse: (response) => response.response,
      invalidatesTags: ["ServerProductsQuotes"],
    }),
  }),
});

export const {
  useGetAllResellerProductsQuery,
  useGetDistinctAttributesQuery,
  useGetProductByIdQuery,
  useLazyGetProductByIdQuery,
  useGetAllResellerProductsByCountryIdQuery,
  useLazyGetAllResellerProductsByCountryIdQuery,
  useGetWoocommerceSiteProductsMutation,
  usePostProductMutation,
  usePutProductMutation,
  useQuickPriceUpdateMutation,
  useReorderProductsMutation,
  useReorderProductsWithoutAutoRefetchMutation,
  useConvertProductMutation,
  useDeleteProductMutation,
  useGetProductImagesByProductIdMutation,
  useLazyGetProductImagesByProductIdQuery,
  useDeleteProductImageMutation,
  useUploadProductImageMutation,
  useResetFeaturedProductsMutation,

  useGetAllServerProductsByCountryIdQuery,
  useLazyGetAllServerProductsByCountryIdQuery,
  useGetServerProductByIdQuery,
  useLazyGetServerProductByIdQuery,
  usePostServerProductMutation,
  usePutServerProductMutation,
  useDeleteServerProductMutation,
  useGetServerProductImagesByProductIdQuery,
  useLazyGetServerProductImagesByProductIdQuery,
  useDeleteServerProductImageMutation,
  useUploadServerProductImageMutation,

  useGetAllServerProductsQuotesByCountryIdQuery,
  useLazyGetAllServerProductsQuotesByCountryIdQuery,
  usePutServerProductQuoteMutation,
  useDeleteServerProductQuoteMutation,
} = productsService;
